import React, { useState } from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";

const TypeSelectDropDown = ({ data, setSelectedType, selectedType }) => {
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("Click here to slecet account type");
  const [hover, setHover] = useState(null);
  return (
    <div
      style={{
        width: "100%",
        height: 80,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 100,
      }}
    >
      <div
        onClick={open ? null : () => setOpen(true)}
        style={{
          borderStyle: "solid",
          width: "90%",
          height: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderWidth: 0.5,
          textAlign: "left",
          position: "relative",
          cursor: "pointer",
        }}
      >
        <div style={{ width: "100%", textAlign: "left", marginLeft: 10 }}>
          {selectedType === "" ? type : selectedType}
        </div>
        <div
          style={{
            position: "absolute",
            height: open ? 200 : 0,
            overflow: "hidden",
            width: "100%",
            transition: "all 0.3s",
            top: 0,
            WebkitBoxShadow: open ? "0px 0px 10px 5px #00000033" : null,
          }}
        >
          {data.map((type, index) => {
            return (
              <div
                onMouseOver={() => setHover(index)}
                onMouseOut={() => setHover(null)}
                onClick={() => {
                  setOpen(false);
                  setType(type);
                  setSelectedType(type);
                }}
                style={{
                  backgroundColor:
                    hover === index
                      ? BlackAndWhite.primary
                      : BlackAndWhite.secondary,
                  width: "100%",
                  height: 40,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 100,
                  // borderStyle: "solid",
                  // borderWidth: 0.5,
                }}
                key={index}
              >
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                    marginLeft: 20,
                    color:
                      hover === index
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary,
                  }}
                >
                  {type}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TypeSelectDropDown;
